/**
 * Tablet breakpoint constant for responsive component styling.
 *
 * Usage: `[theme.fn.smallerThan(TABLET_BREAKPOINT)]: { ... }`
 *
 * Mantine v6: smallerThan(1025) generates `@media (max-width: 64em)`
 * which targets screens with width ≤ 1024px (tablets and below).
 *
 * The general sizing rule: lg → md, md → sm, sm → xs on tablet.
 */
export const TABLET_BREAKPOINT = 1025;

/**
 * Mobile breakpoint constant for explicit mobile-only behavior.
 *
 * Mantine `smallerThan(769)` targets screens with width ≤ 768px.
 */
export const MOBILE_BREAKPOINT = 769;
